import store from "@/store";

// eslint-disable-next-line no-unused-vars
export function afterEach (to, from) {
    store.dispatch('hideLoading')
}
